import { EntityListSkuQuantityInputData } from '../entityListTypes';
import { ImportFormatDataType, ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { InputFormatProvider } from './InputFormatProvider';

export class SkuQuantityInputFormatProvider extends InputFormatProvider<EntityListSkuQuantityInputData> {
  getInputFormat(): ImportFormatItem<EntityListSkuQuantityInputData>[] {
    return [
      {
        id: 'product',
        label: 'Product ID',
        dataType: ImportFormatDataType.STRING,
      },
      {
        id: 'store',
        label: 'Store ID',
        dataType: ImportFormatDataType.STRING,
      },
      {
        id: 'count',
        label: 'Quantity',
        dataType: ImportFormatDataType.NUMBER,
      },
    ];
  }
}
